// extracted by mini-css-extract-plugin
export var container = "MeritSection-module--container--16Nna";
export var inner = "MeritSection-module--inner--3--Jo";
export var boxes = "MeritSection-module--boxes--1VKzd";
export var box = "MeritSection-module--box--3m3qX";
export var img = "MeritSection-module--img--WmsRt";
export var title = "MeritSection-module--title--1idyo";
export var paragraph = "MeritSection-module--paragraph--mQsbM";